import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import partsImg from '../../../images/parts-pic.jpg';
import Drawer from '../../../components/Drawer';
import CreateStockpicking from './_components/createStockpicking';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useCycleCountApi } from '../../../store/api/hooks/cycleCountApiHook';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { downloadExcel, downloadPDF, showLocalDate } from '../../../_common/functions';
import ViewStockpicking from './_components/viewStockpicking';
import { filterConfigType } from '../../../_config/types';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import Filters from '../../../components/filters';
import toast from 'react-hot-toast';
import Loader from '../../../components/loader';
import { PAGE_SIZE } from '../../../_common/constant';
//import CreateReceipt from './_components/createReceipt';

const StockPicking: React.FC = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setRowData] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [viewData, setViewData] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [isRemainingQtyFilter, setIsRemainingQtyFilter] = useState<boolean>(true);
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('stockPickingFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('stockPickingFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const filterConfig: filterConfigType[] = [
        { name: 'Pick No', type: 'text', key: 'pickNo' },
        { name: 'Task Id', type: 'text', key: 'refWorkorderIDs' },
        { name: 'Picking Date', type: 'date', key: 'pickingDate' },
        { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption ? facilityoption : [] },

    ]
    const commonApi: any = useCommonApi();
    const cycleCountAPI = useCycleCountApi();
    const addNewCycledCountRef: any = useRef();
    const addNewCycleCountRef: any = useRef();
    const facilityApi: any = useFacilitiesApi();


    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "view":
                // Implement edit action
                setViewData(rowData);
                addNewCycleCountRef?.current?.open();
                break;
            case "edit":
                // Implement edit action
                setEditData(rowData);
                addNewCycleCountRef?.current?.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "downloadPdf":

                break;
            case "downloadXlsx":

                break;
            case "delete":
                // Implement delete action

                break;


            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const handleClose = () => setIsOpen(false);
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Pick No', field: 'pickNo', headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Pick Date', field: 'pickingDate', headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => <p>{showLocalDate(data.value)}</p> },
        { headerName: 'Picked By', field: 'pickedByName', headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Task Number', field: 'workOrderCode', headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Number of Parts', field: 'pickQuantity', headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Facility', field: 'facilityName', flex: 1, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,

            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            {params?.data?.workOrderCode ? <option value="view">View</option> : <option value="view">View</option>}
                            {/* <option value="downloadXlsx">Download Xlsx</option>
                            <option value="downloadPdf">Download Pdf</option> */}
                        </select>
                    </div>
                );
            },

        }
    ];

    // Define row data


    // GetStockPickingList

    const GetStockPickingList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            isRemainingQtyFilter:isRemainingQtyFilter
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        cycleCountAPI.GetStockPickingList(payload, (resp: any) => {
            console.log('Cycle Count List', resp);
            setRowData(resp.stockPickList ? resp.stockPickList : []);
            setTotalRecords(resp.totalRecord);
        }, (error: any) => {
            setRowData([]);
            setTotalRecords(0);
        });
    };
    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes() ?? [];
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkMoveAssets = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);

        // Example: Perform deletion action, removing selected rows from the rowData
        // In real implementation, you would remove the selected data from your state or backend
        //gridApi.applyTransaction({ remove: selectedData });
    };

    const onBulkExport = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
    };


    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        const payload: any = { isRemainingQtyFilter: isRemainingQtyFilter };
        if (selectedData.length > 0) {
            const stockPickIDs = selectedData.map((asset: any) => asset.stockPickID).join(',');
            payload.stockPickIDs = stockPickIDs;
        }
        cycleCountAPI.ExportPickingToPDF(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'stock_picking');
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        const payload: any = { isRemainingQtyFilter: isRemainingQtyFilter };
        if (selectedData.length > 0) {
            const stockPickIDs = selectedData.map((asset: any) => asset.stockPickID).join(',');
            payload.stockPickIDs = stockPickIDs;
        }
        cycleCountAPI.ExportPickingToXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'stock_picking') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    // Call GetStockPickingList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetStockPickingList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            GetStockPickingList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters]);

    useEffect(() => {
        facilityApi.getFacilityList({}, (resp: any) => {
            let facilitylist: any = [];
            resp.facilityList.map((facilist: any) => {
                facilitylist.push({
                    label: facilist.facilityName,
                    value: facilist.facilityID,
                    data: facilist
                });
            });

            setFacilityoption(facilitylist);
        }, (error: any) => {
            console.log("error =>", error);
        });
    }, []);


    return (
        <Layout>
            <Header title='Stock Picking'>
                <Header.Right>
                    <Drawer _ref={addNewCycleCountRef} onClose={() => {
                        setEditData(null);

                        addNewCycledCountRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Add New'} Stock Picking</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Stock Picking' : (viewData ? 'Stock Picking' : 'Create New Stock Picking')} className='!w-[39.563rem]'>
                            {viewData ?
                                <ViewStockpicking _ref={addNewCycledCountRef} viewData={viewData} onCreate={() => {
                                    setEditData(null);
                                    GetStockPickingList();
                                    addNewCycleCountRef?.current?.close();
                                }} onCancel={() => {
                                    setEditData(null);
                                    setViewData(null);
                                    addNewCycleCountRef?.current?.close();
                                }} />
                                :
                                <CreateStockpicking _ref={addNewCycledCountRef} editData={editData} onCreate={() => {
                                    setEditData(null);
                                    GetStockPickingList();
                                    addNewCycleCountRef?.current?.close();
                                }} onCancel={() => {
                                    setEditData(null);
                                    addNewCycleCountRef?.current?.close();
                                }} />

                            }
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div>
                <div className='flex items-center justify-between px-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}

                    />
                    <Search onSearch={setSearchParam} />
                </div>
                <div className='bg-[#FAFAFA]'>
                    <div className='flex items-center justify-between'>
                        <div className='flex gap-4 px-5 py-2 items-center'>
                            <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>

                            <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                                setFilters({});
                                localStorage.removeItem('stockPickingFilters');
                                setFiltersApplied({ generalFilter: false });
                                setCurrentPage(1);
                            }} >Clear Filters</p>
                        </div>

                        <div className='flex items-center gap-2 text-sm text-gray-600 font-medium'>
                            <input type="checkbox" checked={isRemainingQtyFilter} onChange={(e) => { setIsRemainingQtyFilter(e.target.checked) }} className='w-4 h-4 accent-gray-600' /> Remaining Quantity
                        </div>
                    </div>
                    
                    <div className="ag-theme-alpine mx-4  h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData || []} // Pass rowData
                            pagination={false}
                            domLayout="autoHeight"
                            onGridReady={onGridReady}
                            rowSelection="multiple"
                            onRowClicked={onRowClicked}
                            loadingOverlayComponent={Loader}
                            noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                        />
                    </div>
                </div>
                {/* Add your component code here */}
                <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={(data) => {
                    console.log('On Submit Filters =>', data);
                    setFilters(data);
                }} />
            </div>
        </Layout>
    );
};

export default StockPicking;